<div fxLayout="column" fxFlex="grow" class="dialog__container">
    <div class="actions">
      <p>The package status has been updated by someone else. You cannot proceed with this action. Please refresh the screen.</p>
    </div>
    <div class="actions" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="30px" fxLayout.xs="column"
      fxLayout.sm="column">
      <button fxFlex="40" mat-raised-button color="primary" (click)="refreshPackage()" type="button">Refresh</button>
    </div>
  </div>
